import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

import reportWebVitals from './reportWebVitals';
import './assets/css/kewnda.css';

import { withAuthContext } from './Auth/context';
import { withBookingContext } from './Booking/context';

import Home from './Home';
import OffersList from './Offers';
import BookingForm from './Booking';
import Login from './Auth/Login';
import SignUp from './Auth/SignUp';
import Profile from './Account';
import ForgotPassword from './Account/ForgotPassword';
import PasswordReset from './Account/PasswordReset';
import Changelog from './changelog';
import EmailConfirmation from './Auth/EmailConfirmation';
import LogoutSuccess from './Auth/LogoutSuccess';
import ComingSoon from './Home/ComingSoon';
import About from './Static/about';
import FAQ from './Static/faq';
import PrivacyPolicy from './Static/privacy';
import StagingBanner from './common/StagingBanner';

import { IS_STAGING_ENV } from './constants';

Sentry.init({
  dsn: 'https://58fbe311d229bcce1ac1a43ae5142643@o74086.ingest.us.sentry.io/4509025356218368'
});

const routes = [
  {
    path: '',
    index: true,
    element: <Home />,
  },
  {
    path: 'offers',
    element: <OffersList />,
  },
  {
    path: 'booking/:id',
    element: <BookingForm />,
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'signup',
    element: <SignUp />,
  },
  {
    path: 'profile',
    element: <Profile />,
  },
  {
    path: 'forgot_password',
    element: <ForgotPassword />,
  },
  {
    path: 'password_reset/:token',
    element: <PasswordReset />,
  },
  {
    path: 'email_confirmation',
    element: <EmailConfirmation />,
  },
  {
    path: 'about',
    element: <About />,
  },
  {
    path: 'faqs',
    element: <FAQ />,
  },
  {
    path: 'privacy_policy',
    element: <PrivacyPolicy />,
  },
  {
    path: 'changelog',
    element: <Changelog />,
  },
  {
    path: 'logout_success',
    element: <LogoutSuccess />
  },
  {
    path: '*',
    element: <ComingSoon />,
  },
];

const router = createBrowserRouter([
  {
    path: '/',
    // element: <HomeRouteEl />,
    children: routes
  },
  {
    path: '/:referral_code',
    // element: <ReferralRouteEl />,
    children: routes
  },
]);

const App = () => (
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

const withTestingBanner = WrappedComponent =>
  function Wrapper() {
    return (
      <div>
        <WrappedComponent />
        {IS_STAGING_ENV && <StagingBanner />}
      </div>
    );
  };
const AppWithContext = withAuthContext(withBookingContext(withTestingBanner(App)));

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppWithContext />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
